export enum DownloadState {
  INIT = 'INIT',
  LOADING = 'LOADING',
  CAPTCHA_ERROR = 'CAPTCHA_ERROR',
  NOT_FOUND_ERROR = 'NOT_FOUND_ERROR',
  VALIDATION_ERROR = 'VALIDATION_ERROR',
  UNEXPECTED_ERROR = 'UNEXPECTED_ERROR',
  OK = 'OK',
}
